import { useAuth } from "@/lib/auth-context";
import CompradorAReceber from "./comprador/receber";
import ProdutorReceber from "./produtor/receber";

/**
 * "A receber" — a MESMA rota para os dois lados do balcão.
 *
 * ⚠️ Quem decide o conteúdo é `organizations.tipo`, aqui, exatamente como na home
 * do módulo: o produtor vê o que os compradores lhe devem pelos romaneios; o
 * corretor, o que os destinos devem pelas cargas entregues. Duas URLs para "o que
 * têm a me pagar" seriam dois lugares para o link errado apontar — e o gate de
 * verdade continua no servidor, em rotas separadas.
 *
 * ⚠️ O DISTRIBUIDOR cai aqui só por URL digitada: o item de menu não existe para
 * ele (`ModuleNavItem.perfilComprador`) e a rota do servidor responde 403
 * `PERFIL_INVALIDO`. A tela mostra o erro que veio, em vez de fingir uma lista
 * vazia.
 */
export default function MercadoReceberPage() {
  const { user } = useAuth();
  return user?.orgTipo === "COMPRADOR" ? <CompradorAReceber /> : <ProdutorReceber />;
}
